export const ACCESS_TOKEN = 'access_token';
export const MS_HOST = 'msHost';
export const MS_VERSION = 'msVersion';
export const ODIN_API = 'odinApi';
export const IS_MOCK = 'isMock';
export const YS_PRO_INSTANCE = 'YSProInstance';
export const SMARTWEAR_WEB_SHEET = 'smartwearWebSheet';
